<p-dialog
  data-testid="logistics-dialog"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '500px' }"
  [header]="
    editMode
      ? ('inbound.actions.edit' | translate) +
        ' ' +
        ('inbound.sections.logistics_information' | translate)
      : ('inbound.actions.add' | translate) +
        ' ' +
        ('inbound.sections.logistics_information' | translate)
  "
  (onHide)="onCancel()"
>
  <form data-testid="logistics-dialog-form" [formGroup]="logisticsForm" class="p-fluid">
    <div class="grid grid-cols-1 gap-4">
      <!-- Logistics Company ID -->
      <div class="field">
        <label
          for="logisticsCompanyId"
          class="block text-sm font-medium text-gray-700 mb-2"
        >
          {{ "inbound.fields.logistics_company_id" | translate }}
          <span class="text-red-500">*</span>
        </label>
        <p-inputNumber
          data-testid="logistics-dialog-company-id-input"
          id="logisticsCompanyId"
          formControlName="logisticsCompanyId"
          [placeholder]="
            'inbound.placeholders.enter_logistics_company_id' | translate
          "
          [min]="1"
          [max]="999999999"
          [useGrouping]="false"
          class="w-full"
        ></p-inputNumber>
        @if (getFieldError("logisticsCompanyId")) {
          <small class="text-red-500 mt-1 block">{{
            getFieldError("logisticsCompanyId")
          }}</small>
        }
      </div>

      <!-- Logistics Company Name -->
      <div class="field">
        <label
          for="logisticsCompanyName"
          class="block text-sm font-medium text-gray-700 mb-2"
        >
          {{ "inbound.fields.logistics_company_name" | translate }}
          <span class="text-red-500">*</span>
        </label>
        <input
          data-testid="logistics-dialog-company-name-input"
          pInputText
          id="logisticsCompanyName"
          formControlName="logisticsCompanyName"
          [placeholder]="
            'inbound.placeholders.enter_logistics_company_name' | translate
          "
          class="w-full"
        />
        @if (getFieldError("logisticsCompanyName")) {
          <small class="text-red-500 mt-1 block">{{
            getFieldError("logisticsCompanyName")
          }}</small>
        }
      </div>

      <!-- Logistics Number -->
      <div class="field">
        <label
          for="logisticsNo"
          class="block text-sm font-medium text-gray-700 mb-2"
        >
          {{ "inbound.fields.logistics_number" | translate }}
          <span class="text-red-500">*</span>
        </label>
        <input
          data-testid="logistics-dialog-number-input"
          pInputText
          id="logisticsNo"
          formControlName="logisticsNo"
          [placeholder]="
            'inbound.placeholders.enter_logistics_number' | translate
          "
          class="w-full"
        />
        @if (getFieldError("logisticsNo")) {
          <small class="text-red-500 mt-1 block">{{
            getFieldError("logisticsNo")
          }}</small>
        }
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <app-button
        [testId]="'logistics-dialog-cancel-btn'"
        label="inbound.actions.cancel"
        type="secondary"
        [outlined]="true"
        (emitOnClick)="onCancel()"
        [disabled]="loading()"
      ></app-button>
      <app-button
        [testId]="'logistics-dialog-save-btn'"
        [label]="editMode ? 'inbound.actions.update' : 'inbound.actions.add'"
        type="info"
        (emitOnClick)="onSave()"
        [disabled]="loading()"
      ></app-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Toast Messages -->
<p-toast data-testid="logistics-dialog-toast"></p-toast>
